import Cookies from 'universal-cookie';
import React from "react";

import _it from './it.json';
import _en from './en.json';

export default class LanguagesUtils extends React.Component {

    static language = 'it';
    static translationArray = {};
       
    static changeLanguage(_lang){
        const cookies = new Cookies();
        cookies.set('language', _lang, { path: '/' });
        LanguagesUtils.language = _lang;
        if (_lang == 'it')
            LanguagesUtils.translationArray = _it;
        else if (_lang == 'en')
            LanguagesUtils.translationArray = _en;
    }


    static tr(_string){
        const str = LanguagesUtils.translationArray[_string];
        if (str === null || str === undefined || str == ''){
            alert (_string + ' NOT FOUND!');
        }

        return str;
    }

}